<template>
  <div class="columns">
    <div
      v-if="!isMobile"
      class="column is-gapless is-2 date-displayer-button"
      style="text-align: center;"
      :class="{ 'button-pressed': todayButtonPressed }"
      @click="todayClicked"
    >
      Today
    </div>
    <div class="column is-gapless is-8" style="text-align: center;">
      <div class="date-picker-holder">
        <svg
          class="arrow"
          @click="clickPrevious"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 17 17"
        >
          <g></g>
          <path
            d="M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z"
          ></path>
        </svg>
        <flat-pickr
          ref="datePicker"
          :config="config"
          v-model="dates"
          @on-open="flatPickrOpened"
          @on-close="flatPickrClosed"
          @on-change="flatPickrChange"
        ></flat-pickr>
        <svg
          class="arrow"
          @click="clickNext"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 17 17"
        >
          <g></g>
          <path
            d="M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z"
          ></path>
        </svg>
      </div>
    </div>
    <div
      v-if="isMobile"
      class="column is-gapless is-one-half date-displayer-button"
      style="text-align: center;"
      :class="{ 'button-pressed': todayButtonPressed }"
      @click="todayClicked"
    >
      Today
    </div>
    <div
      class="column is-gapless is-one-half-tablet is-2-desktop date-displayer-button"
      style="text-align: center;"
    >
      <div
        class="dropdown"
        @click="dropdownOpen = !dropdownOpen"
        :class="{ 'is-active': dropdownOpen }"
      >
        <div :class="{ 'modal-curtain': dropdownOpen }"></div>
        <div class="dropdown-trigger" style="width: 90px">
          <button
            class="day-week-or-month-button"
            aria-haspopup="true"
            aria-controls="dropdown-menu"
          >
            <span class="day-week-or-month">{{ dayWeekOrMonth }}</span>
          </button>
        </div>
        <div class="dropdown-menu" role="menu" style="left: 1px !important">
          <div class="dropdown-content" style="width: 88px;">
            <a
              :class="{ hidden: !otherDays }"
              @click="dropdownClicked('Other')"
              class="dropdown-item"
            >
              {{ dayWeekOrMonth }}
            </a>
            <hr :class="{ hidden: !otherDays }" class="dropdown-divider" />
            <a @click="dropdownClicked('Day')" class="dropdown-item">
              Day
            </a>
            <hr class="dropdown-divider" />
            <a @click="dropdownClicked('Week')" class="dropdown-item">
              Week
            </a>
            <hr class="dropdown-divider" />
            <a @click="dropdownClicked('Month')" class="dropdown-item">
              Month
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
Vue.use(flatPickr);

const dayInMilliseconds = 24 * 60 * 60 * 1000;

export default {
  name: "DateDisplayer",
  components: {
    flatPickr
  },
  data: function() {
    return {
      dates: [new Date(), new Date().getTime() + 6 * dayInMilliseconds],
      config: {
        altFormat: "M j, Y",
        dateFormat: "M j, Y",
        shorthandCurrentMonth: true,
        enableTime: false,
        minDate: new Date().setHours(0, 0, 0, 0), // fixes bug where dates would be have times lower than set and disappear
        mode: "range",
        defaultDate: [new Date(), new Date().getTime() + 6 * dayInMilliseconds]
      },
      minMonth: new Date().getMonth(),
      minYear: new Date().getFullYear(),
      allMonthsDisplayed: false,
      flatPickrOpen: false,
      modalCalendar: null,
      dropdownOpen: false,
      dayWeekOrMonth: "Week",
      otherDays: null,
      wasMobile: false,
      todayButtonPressed: false
    };
  },
  methods: {
    flatPickrOpened() {
      this.flatPickrOpen = true;
      if (this.calendarLeftEdge > 0) {
        this.$nextTick(function() {
          this.modalCalendar.style.left = this.calendarLeftEdge + "px";
        });
      }
    },
    flatPickrClosed(event) {
      this.flatPickrOpen = false;
      if (
        event.length == 1 ||
        event[0].getTime() == event[1].getTime() // identical dates objects not equal in javascript
      ) {
        // record the date when a single date is clicked and then the modal closed
        // or if a single date is selected as the start and finish
        this.dates = [event[0], event[0]];
      } else {
        // record if multiple dates are closed so that updateOtherDays can run
        this.dates = [event[0], event[1]];
      }
      this.updateOtherDays();
    },
    flatPickrChange() {
      // fix the left edge of the calendar
      if (this.calendarLeftEdge > 0) {
        this.$nextTick(function() {
          this.modalCalendar.style.left = this.calendarLeftEdge + "px";
        });
      }
    },
    clickPrevious() {
      if (this.dayWeekOrMonth == "Month") {
        // eslint-disable-next-line
        let tempTimestamp =
          new Date(this.dates.split(" to ")[0]).setHours(2, 0, 0, 0);
        if (new Date(tempTimestamp).getMonth() == 0) {
          // January 1st - January 31st
          tempTimestamp = new Date(
            new Date(tempTimestamp).setMonth(11)
          ).setFullYear(new Date(tempTimestamp).getFullYear() - 1);
        } else {
          // February 1st - December 31st
          tempTimestamp = new Date(
            new Date(tempTimestamp).setMonth(
              new Date(tempTimestamp).getMonth() - 1
            )
          ).getTime();
        }
        if (tempTimestamp < this.config.minDate) {
          this.adjustCalendarWithDropdownAndFirstDate(
            new Date().setHours(2, 0, 0, 0)
          );
        } else {
          this.adjustCalendarWithDropdownAndFirstDate(tempTimestamp);
        }
      } else {
        const daysBetweenDates = this.getDaysBetweenDates();
        const tempTimestamps = daysBetweenDates[1];
        if (
          tempTimestamps[0] - (daysBetweenDates[0] + 1) * dayInMilliseconds <
          this.config.minDate
        ) {
          const newDate = new Date().setHours(2, 0, 0, 0);
          this.dates = [
            newDate,
            newDate + daysBetweenDates[0] * dayInMilliseconds
          ];
        } else {
          this.dates = [
            tempTimestamps[0] - (daysBetweenDates[0] + 1) * dayInMilliseconds,
            tempTimestamps[1] - (daysBetweenDates[0] + 1) * dayInMilliseconds
          ];
        }
      }
      this.fixDropdownMonths();
    },
    clickNext() {
      if (this.dayWeekOrMonth == "Month") {
        let tempTimestamp =
          new Date(this.dates.split(" to ")[0]).setHours(2, 0, 0, 0) +
          dayInMilliseconds;
        if (new Date(tempTimestamp - dayInMilliseconds).getMonth() < 11) {
          // January 2 - December 1st
          tempTimestamp =
            new Date(
              new Date(tempTimestamp).setMonth(
                new Date(tempTimestamp).getMonth() + 1
              )
            ).getTime() - dayInMilliseconds;
        } else {
          // December 2nd - January 1st
          tempTimestamp = new Date(
            new Date(tempTimestamp - dayInMilliseconds).setMonth(0)
          ).setFullYear(new Date(tempTimestamp).getFullYear() + 1);
        }
        this.adjustCalendarWithDropdownAndFirstDate(tempTimestamp);
      } else {
        const daysBetweenDates = this.getDaysBetweenDates();
        const tempTimestamps = daysBetweenDates[1];
        this.dates = [
          tempTimestamps[0] + (daysBetweenDates[0] + 1) * dayInMilliseconds,
          tempTimestamps[1] + (daysBetweenDates[0] + 1) * dayInMilliseconds
        ];
      }
      this.fixDropdownMonths();
    },
    todayClicked() {
      this.todayButtonPressed = true;
      setTimeout(() => {
        this.todayButtonPressed = false;
      }, 100);
      const tempTimestamp = new Date().setHours(2, 0, 0, 0);
      this.adjustCalendarWithDropdownAndFirstDate(tempTimestamp);
    },
    dropdownClicked(value) {
      this.dayWeekOrMonth = value;
      // normalize first date to a timestamp for adjustment
      // note that setting the hour to 0200 mitigates daylight savings changes
      let tempTimestamp;
      if (this.dates.length != 2) {
        let dateStrings = this.dates.split(" to ");
        tempTimestamp = new Date(dateStrings[0]).setHours(2, 0, 0, 0);
      } else {
        // can receive either UTC or timestamps, and this fixes it
        tempTimestamp = new Date(this.dates[0]).setHours(2, 0, 0, 0);
      }

      // set the calendar
      this.adjustCalendarWithDropdownAndFirstDate(tempTimestamp);

      // update other days
      this.updateOtherDays();
    },
    adjustCalendarWithDropdownAndFirstDate(tempTimestamp) {
      switch (this.dayWeekOrMonth) {
        case "Day":
          this.dates = [tempTimestamp, tempTimestamp];
          break;
        case "Week":
          this.dates = [tempTimestamp, tempTimestamp + 6 * dayInMilliseconds];
          break;
        case "Month":
          if (new Date(tempTimestamp - dayInMilliseconds).getMonth() < 11) {
            // January 2 - December 1st
            this.dates = [
              tempTimestamp,
              new Date(
                new Date(tempTimestamp).setMonth(
                  new Date(tempTimestamp).getMonth() + 1
                )
              ).getTime() - dayInMilliseconds
            ];
          } else {
            // December 2nd - January 1st
            this.dates = [
              tempTimestamp,
              new Date(
                new Date(tempTimestamp - dayInMilliseconds).setMonth(0)
              ).setFullYear(
                new Date(tempTimestamp - dayInMilliseconds).getFullYear() + 1
              )
            ];
          }
          break;
        default:
          this.dates = [
            tempTimestamp,
            new Date(
              tempTimestamp + this.getDaysBetweenDates()[0] * dayInMilliseconds
            ).setHours(2, 0, 0, 0)
          ];
          break;
      }
    },
    getDaysBetweenDates() {
      let tempTimestamps = [];
      if (this.dates.length != 2) {
        // change from baseline value
        let dateStrings = this.dates.split(" to ");
        if (dateStrings.length == 1) {
          tempTimestamps = [
            new Date(dateStrings[0]).setHours(2, 0, 0, 0),
            new Date(dateStrings[0]).setHours(2, 0, 0, 0)
          ];
        } else {
          tempTimestamps = [
            new Date(dateStrings[0]).setHours(2, 0, 0, 0),
            new Date(dateStrings[1]).setHours(2, 0, 0, 0)
          ];
        }
      } else {
        tempTimestamps = [
          new Date(this.dates[0]).setHours(2, 0, 0, 0),
          new Date(this.dates[1]).setHours(2, 0, 0, 0)
        ];
      }
      return [
        Math.round((tempTimestamps[1] - tempTimestamps[0]) / dayInMilliseconds),
        tempTimestamps
      ];
    },
    updateOtherDays() {
      const daysBetweenDates = this.getDaysBetweenDates();
      if (daysBetweenDates[0] == 0) {
        this.otherDays = false;
        this.dayWeekOrMonth = "Day";
      } else if (daysBetweenDates[0] == 6) {
        this.otherDays = false;
        this.dayWeekOrMonth = "Week";
      } else if (daysBetweenDates[0] >= 90) {
        this.otherDays = true;
        this.dayWeekOrMonth = "90+ Days";
      } else if (daysBetweenDates[0] >= 28 && daysBetweenDates[0] <= 31) {
        const tempTimestamps = daysBetweenDates[1];
        if (new Date(tempTimestamps[0] - dayInMilliseconds).getMonth() < 11) {
          // January 2nd - December 1st
          if (
            tempTimestamps[1] ==
            new Date(
              new Date(tempTimestamps[0]).setMonth(
                new Date(tempTimestamps[0]).getMonth() + 1
              )
            ).getTime() -
              dayInMilliseconds
          ) {
            this.otherDays = false;
            this.dayWeekOrMonth = "Month";
          } else {
            this.otherDays = true;
            this.dayWeekOrMonth = daysBetweenDates[0] + " Days";
          }
        } else {
          // December 2nd - January 1st
          if (
            tempTimestamps[1] ==
            new Date(
              new Date(tempTimestamps[0] - dayInMilliseconds).setMonth(0)
            ).setFullYear(
              new Date(tempTimestamps[0] - dayInMilliseconds).getFullYear() + 1
            )
          ) {
            this.otherDays = false;
            this.dayWeekOrMonth = "Month";
          } else {
            this.otherDays = true;
            this.dayWeekOrMonth = daysBetweenDates[0] + " Days";
          }
        }
      } else {
        this.otherDays = true;
        this.dayWeekOrMonth = daysBetweenDates[0] + 1 + " Days";
      }
    },
    fixDropdownMonths() {
      const monthValues = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      const currentYear = new Date(this.dates[1]).getFullYear();
      if (currentYear > this.minYear) {
        if (!this.allMonthsDisplayed) {
          let keyNode = document.getElementsByClassName(
            "flatpickr-monthDropdown-months"
          )[0];
          while (keyNode.lastChild) {
            keyNode.removeChild(keyNode.lastChild);
          }
          for (let i = 0; i < monthValues.length; i++) {
            let element = document.createElement("OPTION");
            element.setAttribute("class", "flatpickr-monthDropdown-month");
            element.setAttribute("tabindex", "-1");
            element.value = i;
            const subElement = document.createTextNode(monthValues[i]);
            element.appendChild(subElement);
            keyNode.appendChild(element);
          }
        }
        this.allMonthsDisplayed = true;
      } else {
        if (this.allMonthsDisplayed) {
          let keyNode = document.getElementsByClassName(
            "flatpickr-monthDropdown-months"
          )[0];
          while (keyNode.lastChild) {
            keyNode.removeChild(keyNode.lastChild);
          }
          for (let i = this.minMonth; i < monthValues.length; i++) {
            let element = document.createElement("OPTION");
            element.setAttribute("class", "flatpickr-monthDropdown-month");
            element.setAttribute("tabindex", "-1");
            element.value = i;
            const subElement = document.createTextNode(monthValues[i]);
            element.appendChild(subElement);
            keyNode.appendChild(element);
          }
        }
        this.allMonthsDisplayed = false;
      }
    }
  },
  computed: {
    isMobile: {
      get() {
        return this.$store.state.isMobile;
      }
    },
    calendarLeftEdge: {
      get() {
        // Center modal calendar with heading
        if (this.$store.state.appWidth) {
          // ensures this updates if appWidth changes
        }
        const inputBoundingClientRects = this.$refs.datePicker.$el.getBoundingClientRect();
        if (inputBoundingClientRects.width) {
          // see if the width attribute is supported in the browser (it should be)
          return (
            inputBoundingClientRects.left -
            (this.modalCalendar.getBoundingClientRect().width -
              inputBoundingClientRects.width) /
              2
          );
        } else {
          return 0;
        }
      }
    }
  },
  watch: {
    dates() {
      if (this.dates.length == 2) {
        // hasn't been converted into date string by flatPickr
        this.$store.state.scheduledListBounds = [
          new Date(this.dates[0]).setHours(0, 0, 0, 0),
          new Date(this.dates[1]).setHours(0, 0, 0, 0)
        ];
      }
    }
  },
  mounted() {
    // convert dates into string for consistency
    this.dates = [new Date(this.dates[0]), new Date(this.dates[1])];

    // add modalCalendar to data
    this.modalCalendar = document.getElementsByClassName(
      "flatpickr-calendar"
    )[0];

    // Fix focus and keypresses on calendar year.
    let datePickerYearInput = document.getElementsByClassName("numInput")[0];
    function stopEventPropagation(event) {
      if (event.key == "Enter" || event.key == "Escape") {
        document.activeElement.blur();
      }
      event.stopPropagation();
    }
    datePickerYearInput.addEventListener("click", function() {
      this.type = "text";
      this.selectionStart = 4;
      this.selectionEnd = 4;
      this.type = "number";
    });
    datePickerYearInput.addEventListener("focus", function() {
      datePickerYearInput.addEventListener("keydown", stopEventPropagation);
    });
    datePickerYearInput.addEventListener("blur", function() {
      datePickerYearInput.removeEventListener("keydown", stopEventPropagation);
    });
  }
};
</script>
